module.exports = {
    'management' : 'Executive',
    'technical'  : 'Technical',
    'design'     : 'Design',
    'content'    : 'Content',
    'qa'         : 'QA',
    'pmo'        : 'PMO',
    'admin'      : 'Admin'
};